export const skincareLPStructuredData = [
  {
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Custom Cleanser',
        url: 'https://prose.com/products/custom-cleanser',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Custom Serum',
        url: 'https://prose.com/products/custom-serum',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Custom Moisturizer',
        url: 'https://prose.com/products/custom-moisturizer',
      },
    ],
  },
  {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Homepage',
        item: 'https://prose.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Skincare Products',
        item: 'https://prose.com/pages/skincare',
      },
    ],
  },
  {
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    '@id': '#Organization',
    url: 'https://prose.com/pages/skincare',
    legalName: 'Prose',
    name: 'Prose Custom Skincare',
    description:
      'Get custom skin care formulated to meet all of your unique skin needs and concerns. Prose Custom Cleanser, Serum and Moisturizer are made just for you!',
    image:
      'https://cdn2.prose.com/_next/static/media/fallback-introduction-section-desktop.14a2d978.jpg',
    logo: 'https://prose.com/_next/image?url=https%3A%2F%2Fcdn2.prose.com%2F_next%2Fstatic%2Fmedia%2Fugc_desktop.7496972e.jpg&w=3840&q=75',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '',
      addressLocality: '',
      addressRegion: '',
      addressCountry: '',
      postalCode: '',
    },
    sameAs: ['https://www.instagram.com/prose/?hl=en'],
  },
  {
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    '@id': '#Organization',
    url: 'https://prose.com/pages/skincare',
    legalName: 'Prose',
    name: 'Prose Custom Skincare',
    description:
      'Get custom skin care formulated to meet all of your unique skin needs and concerns. Prose Custom Cleanser, Serum and Moisturizer are made just for you!',
    image:
      'https://cdn2.prose.com/_next/static/media/fallback-introduction-section-desktop.14a2d978.jpg',
    logo: 'https://prose.com/_next/image?url=https%3A%2F%2Fcdn2.prose.com%2F_next%2Fstatic%2Fmedia%2Fugc_desktop.7496972e.jpg&w=3840&q=75',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '',
      addressLocality: '',
      addressRegion: '',
      addressCountry: '',
      postalCode: '',
    },
    sameAs: ['https://www.instagram.com/prose/?hl=en'],
  },

  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What makes Prose skincare different from other brands?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Prose skincare is customized to meet your skin’s unique needs, and formulated to address all combinations of skin concerns. We take into account your skin goals, lifestyle, environment, and ingredient preferences to create custom formulas that bring out your healthiest skin. All Prose skincare products are co-developed with a Skincare Advisory board made up of dermatologists and other skin experts, from cosmetic chemists to endocrinologists.',
        },
      },
      {
        '@type': 'Question',
        name: 'Are the ingredients safe to use?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We believe in using the cleanest and highest-quality ingredients possible. Every ingredient in our skincare is non-comedogenic, and meticulously sourced and researched to ensure safety, quality, and efficacy. While we pull from a robust portfolio of ingredients to address a diverse range of needs, your custom formulas will only contain the ingredients that your skin needs. All Prose skincare products are cruelty-free, vegan, and free of BHT, sulfates, drying alcohols, silicones, and colorants.',
        },
      },
      {
        '@type': 'Question',
        name: 'When can I expect to start seeing results with my products?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'While some individuals may see immediate results, our chemists recommend consistent use of Prose skincare products for four weeks. This allows your skin adequate time to adjust to your custom formulas.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do I have to purchase the entire Prose skincare line?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Prose skincare products are designed to work together for the best results. We’ll recommend a complete skincare routine based on your unique consultation, but you can also opt for individual products. If you use any prescribed skincare topicals, we recommend consulting your doctor before using them with Prose skincare.',
        },
      },
      {
        '@type': 'Question',
        name: 'What if I have an allergy?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Ensuring the safety and efficacy of your formulas is our top priority. Before placing an order, contact us here and let us know if you have any allergies or ingredient sensitivities.',
        },
      },
      {
        '@type': 'Question',
        name: 'Can I try a sample of my Prose skincare?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Because all of our formulas are freshly bottled and made to order, we’re unable to offer samples. Not ready to take the leap? Reach out to us with any questions or concerns — or read more about The Prose Promise™.',
        },
      },
      {
        '@type': 'Question',
        name: 'What if my product looks different from what’s on the website?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Because Prose products are truly custom, each formula is unique. This means that color and scent can vary slightly from formula to formula, even if you choose fragrance-free. For example, your moisturizer might appear white or slightly beige, depending on the active ingredients — but no matter the color, your products are always made to order according to our stringent safety and quality standards.',
        },
      },
    ],
  },
];
